import React from 'react';
import { observer } from 'mobx-react';
// modules
import { useStore } from 'modules/Stores';
// UI
import { View, Text, CloseIcon, Checkbox, Radio } from '@upstox/upstox-ui';
// consts
import { SETTINGS_MENU_CHECKBOX_OPTIONS, SETTINGS_MENU_RADIO_OPTIONS } from 'modules/OptionChain/consts';
// styles
import * as css from './styles';

const SettingsContainer = () => {
  const { setOpenSettings, tableSettings, setTableSettings } = useStore(
    'OptionChainStore',
  );

  const handleCheckboxOptionsSelect = (
    e: React.MouseEvent<HTMLElement>,
    settingsType: keyof OCTableSettings['columnSettings'],
    optionType: ColSettingsOptionType,
  ) => {
    e.stopPropagation();
    setTableSettings({
      columnSettings: {
        ...tableSettings.columnSettings,
        [settingsType]: {
          ...tableSettings.columnSettings[settingsType],
          [optionType]: !tableSettings.columnSettings[settingsType][optionType],
        },
      },
    });
  };

  const handleRadioOptionSelect = (
    e: React.MouseEvent<HTMLElement>,
    settingsType: keyof OCTableSettings['dataSettings'],
    value: OCStrikesSettings | OCChangeSettings,
  ) => {
    e.stopPropagation();
    setTableSettings({
      dataSettings: {
        ...tableSettings.dataSettings,
        [settingsType]: value,
      },
    });
  };

  return (
    <View css={css.container} flex flexDirection="column">
      <View css={css.settingsHeader}>
        <Text css={css.viewText}>View settings</Text>
        <View css={css.iconContainer}>
          <CloseIcon
            css={css.closeIcon}
            onClick={() => setOpenSettings(false)}
          />
        </View>
      </View>
      <View padding={[24, 16, 0]} flexDirection="column">
        {SETTINGS_MENU_CHECKBOX_OPTIONS.map(({ type, label, options }) => (
          <View
            padding={[0, 0, 16]}
            flexDirection="column"
            key={type}
          >
            <View margin={[0, 0, 4, 0]}>
              <Text css={css.blockHeading}>{label}</Text>
            </View>
            <View flex flexDirection="column">
              {options.map(({ label: colLabel, type: colType }) => (
                <View
                  key={colType}
                  alignItems="center"
                  css={css.checkboxContainer}
                  onClick={(e) => handleCheckboxOptionsSelect(e, type, colType)}
                >
                  <Checkbox
                    readOnly
                    checked={tableSettings.columnSettings[type][colType]}
                    isSquare
                    className="checkboxIcon"
                  />

                  <Text css={css.checkboxLabel}>{colLabel}</Text>
                </View>
              ))}
            </View>
          </View>
        ))}
      </View>
      <View flexDirection="column" padding={[0, 16]}>
        {SETTINGS_MENU_RADIO_OPTIONS.map(({ type, label, options }) => (
          <View
            flexDirection="column"
            key={type}
            padding={[0, 0, 16]}
          >
            <View margin={[0, 0, 4, 0]}>
              <Text css={css.blockHeading}>{label}</Text>
            </View>
            <View flexDirection="column">
              {options.map(({ label: colLabel, value }) => (
                <View
                  key={value}
                  alignItems="center"
                  css={css.checkboxContainer}
                  onClick={(e) => handleRadioOptionSelect(e, type, value)}
                >
                  <Radio
                    readOnly
                    checked={value === tableSettings.dataSettings[type]}
                  />

                  <Text css={css.checkboxLabel}>{colLabel}</Text>
                </View>
              ))}
            </View>
          </View>
        ))}
      </View>
    </View>
  );
};

export default observer(SettingsContainer);
